/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { PrefMasterApi } from "../clients";
import { wrap } from "../wrap";

const prefMasterApi = {
  get: wrap(PrefMasterApi, PrefMasterApi.prototype.getPrefectures),
};

export default prefMasterApi;
